import { NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivityFormModalComponent } from '@curbnturf/activity-component/src/lib/add-activity-form/activity-form-modal/activity-form-modal.component';
import { AddActivityFormComponent } from '@curbnturf/activity-component/src/lib/add-activity-form/add-activity-form.component';
import { ActivityLocationFacade } from '@curbnturf/activity/src/lib/+state/activity.facade';
import { AuthModalFacade } from '@curbnturf/auth-modal/src/lib/+state/auth-modal.facade';
import { CategorySvgComponent } from '@curbnturf/custom-svgs/src/lib/category-svg/category-svg.component';
import { SiteSvgsComponent } from '@curbnturf/custom-svgs/src/lib/site-svgs/site-svgs.component';
import {
  ActivityLocation,
  IActivityLocation,
  ILatLon,
  IUser,
  IUserCustomLocation,
  MapPoint,
} from '@curbnturf/entities';
import { ListingSearchFacade } from '@curbnturf/listing-search/src/lib/+state/listing-search.facade';
import { PlatformService } from '@curbnturf/network/src/lib/platform/platform.service';
import { SignUpStateFacade } from '@curbnturf/sign-up-state/src/lib/+state/sign-up-state.facade';
import { StatusFacade } from '@curbnturf/status';
import { UrlControlFacade } from '@curbnturf/url-control/src/lib/+state/url-control.facade';
import { UserCustomLocationService, UserFacade } from '@curbnturf/user';
import { AlertController, IonicModule, ModalController, NavController } from '@ionic/angular';
import { Subscription } from 'rxjs';

@Component({
  standalone: true,
  selector: 'curbnturf-here-map-context-menu',
  templateUrl: './here-map-context-menu.component.html',
  styleUrls: ['./here-map-context-menu.component.scss'],
  imports: [
    ActivityFormModalComponent,
    AddActivityFormComponent,
    CategorySvgComponent,
    IonicModule,
    NgIf,
    SiteSvgsComponent,
  ],
})
export class HereMapContextMenuComponent implements OnInit {
  @Input() contextMenuCoordinates: ILatLon;

  @Output() closeContextMenu: EventEmitter<void> = new EventEmitter<void>();

  loggedIn: boolean = false;
  currentUser: IUser;

  subscriptions: Subscription[] = [];

  constructor(
    private activityLocationFacade: ActivityLocationFacade,
    private alertController: AlertController,
    private authModalFacade: AuthModalFacade,
    private cd: ChangeDetectorRef,
    private listingSearchFacade: ListingSearchFacade,
    private navController: NavController,
    private modalController: ModalController,
    private platformService: PlatformService,
    private signUpFacade: SignUpStateFacade,
    private statusFacade: StatusFacade,
    private urlControlFacade: UrlControlFacade,
    private userCustomLocationService: UserCustomLocationService,
    private userFacade: UserFacade,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.statusFacade.loggedIn$.subscribe((loggedIn) => {
        this.loggedIn = loggedIn;
      }),
      this.userFacade.currentUserOnce$.subscribe((user) => {
        this.currentUser = user;
      }),
    );
  }

  onCreateCustomLocation() {
    // Needs a slight delay to allow the UI to catch up with the coordinates.
    setTimeout(async () => {
      const coordinates: ILatLon = {
        lat: this.contextMenuCoordinates.lat,
        lon: this.contextMenuCoordinates.lon,
      };

      this.closeContextMenu.emit();

      const alert = await this.alertController.create({
        header: 'Add Custom Location',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
          },
          {
            text: 'Save',
            role: 'submit',
            handler: (value) => {
              this.userCustomLocationService
                .create(value.name, coordinates)
                .subscribe((location: IUserCustomLocation) => {
                  const point: MapPoint = new MapPoint({
                    ...location,
                    id: location.id || 0,
                    photos: [],
                  });
                  this.listingSearchFacade.addUserPoint(point);
                });
            },
          },
        ],
        inputs: [
          {
            name: 'name',
            placeholder: 'Location Name',
            attributes: {
              maxlength: 50,
            },
          },
        ],
      });

      await alert.present();
    }, 200);
  }

  onCreateListing(type: string) {
    this.signUpFacade.startNewListingAndFlow(this.currentUser);
  }

  async onBeginAddPoi() {
    this.closeContextMenu.emit();

    if (!this.loggedIn) {
      this.urlControlFacade.setRedirectUrl('/search');

      this.authModalFacade.openAuthModal('login');
    } else {
      this.cd.detectChanges();
      //wait for a split second for the template to update its inputs
      setTimeout(async () => {
        const coordinates: ILatLon = {
          lat: this.contextMenuCoordinates.lat,
          lon: this.contextMenuCoordinates.lon,
        };

        const activity: IActivityLocation = { coordinates };

        this.activityLocationFacade.awaitActivity(activity);

        if (this.platformService.isPhoneSize()) {
          // Prep and Activity to Add with the point location.
          const activityLocation = new ActivityLocation({
            coordinates,
          });

          this.activityLocationFacade.awaitActivity(activityLocation);

          // Send to the Add Activity Form
          await this.navController.navigateForward(['', 'activity', 'add']);
        } else {
          const modal = await this.modalController.create({
            component: ActivityFormModalComponent,
          });
          await modal.present();
        }
      }, 200);
    }
  }
}
